import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { css } from 'linaria';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { CABINET_ELEMENT_BLOCK } from '../../../../cabinet-constants';
import { cabinetBenefitsModalTitle } from '../../cabinet-benefits-styles';

const projectButton = css`
  width: 100%;
`;

export const Project = ({ onCloseModal, signUpHref }: { onCloseModal: () => void; signUpHref: string; }) => (
  <>
    <ModalHeader className={cabinetBenefitsModalTitle} title="Бесплатный дизайн проект" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Наш дизайнер сделает проект совершенно бесплатно: учтёт размеры, общий стиль интерьера и&nbsp;ваши пожелания&nbsp;&mdash; можно онлайн или в&nbsp;одном из&nbsp;магазинов Лемана ПРО.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        className={projectButton}
        onClick={onCloseModal}
        elementBlock={CABINET_ELEMENT_BLOCK}
        elementName="Бесплатный дизайн проект / modal"
        elementText="Записаться на проектирование"
        href={signUpHref}
        target="_blank"
        variant="accent"
        wide
      >
        Записаться на проектирование
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
